export default {
  getAuthUser (games, cb, errorCb) {
    axios.get(`/users/owner?games=${games}`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/api/user.js